import { h } from 'preact'
import { attributesAnalytics } from '../../js/modules/component'

export const FilAriane = ({ items }) => {
   return (
      <div class="bg-dark py-1" data-testid="bande-fil-ariane">
         <div class="container-fluid">
            <nav aria-label="Breadcrumb">
               <ul class="breadcrumb bg-dark text-white p-0 mb-0">
                  {items.map(({ analytics, url, label }, index) => {
                     return index === 0 ? (
                        <li class="breadcrumb-item">
                           <a
                              href={url || '#'}
                              {...attributesAnalytics(analytics)}
                           >
                              {label}
                           </a>
                        </li>
                     ) : index === items.length - 1 ? (
                        <li class="breadcrumb-item" aria-current="page">
                           {label}
                        </li>
                     ) : (
                        <li>
                           <a href={url || '#'}>{label}</a>
                        </li>
                     )
                  })}
               </ul>
            </nav>
         </div>
      </div>
   )
}
